module.exports = __webpack_public_path__ + "img/trial2-2.898fdcbd.png";